"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M4 14C4 13.4477 4.44772 13 5 13H9C9.55228 13 10 13.4477 10 14V24H4V14Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M11 10C11 9.44772 11.4477 9 12 9H16C16.5523 9 17 9.44772 17 10V24H11V10Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M18 5C18 4.44772 18.4477 4 19 4H23C23.5523 4 24 4.44772 24 5V24H18V5Z", fill: "currentColor" })));
